<div class="wrapper">
  <h3>Merchant Downloads</h3>
  <mat-list>
    <ng-container *ngFor="let item of files">
      <div mat-subheader>{{ item.type.name }}</div>
      <mat-list-item *ngFor="let file of item.files">
        <mat-icon mat-list-icon>
          <ng-container *ngIf="file.online">public</ng-container>
          <ng-container *ngIf="!file.online">print</ng-container>
        </mat-icon>
        <div mat-line>{{ file.name }}</div>
        <div mat-line>
          <a [href]="file.fileUrl" target="_blank">Download</a>
        </div>
      </mat-list-item>
      <mat-divider></mat-divider>
    </ng-container>
  </mat-list>
</div>
